<div class="page-container">
  <div class="top-spacer"></div>

  <div *ngIf="isUpdate && (loading$ | async)" class="mat-elevation-z1 shimmer-container">
    <div *ngFor="let _ of [].constructor(10)" class="stencil-shimmer shimmer"></div>
  </div>

  <mat-expansion-panel *ngIf="!isUpdate || (loading$ | async) === false" class="settings-card" expanded="true">
    <mat-expansion-panel-header class="expansion-header">
      <mat-panel-title class="settings-card-title" *ngIf="(isSessionEventType$ | async) === false">
        {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.TITLE' | translate }}
      </mat-panel-title>
      <mat-panel-title
        class="settings-card-title"
        *ngIf="(isSessionEventType$ | async) === true && !showScheduleAccordion"
      >
        {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.SESSION_EVENT_TYPE_TITLE' | translate }}
      </mat-panel-title>
      <mat-panel-title
        class="settings-card-title"
        *ngIf="(isSessionEventType$ | async) === true && showScheduleAccordion"
      >
        {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.SCHEDULE_SESSION_TITLE' | translate }}
      </mat-panel-title>
      <mat-panel-description class="settings-card-description">
        {{ aboutCardDescription }}
      </mat-panel-description>
    </mat-expansion-panel-header>
    <form [formGroup]="form">
      <!-- Name field - Static display for schedule flow, editable for regular flow -->
      <div *ngIf="showScheduleAccordion" class="static-field">
        <span class="field-label">{{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.NAME' | translate }}:&nbsp;</span>
        <span class="field-value">{{ eventTypeName }}</span>
      </div>

      <glxy-form-field *ngIf="!showScheduleAccordion">
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.NAME' | translate }}
        </glxy-label>
        <input matInput required formControlName="name" />
        <glxy-error *ngIf="nameControl.invalid && (nameControl?.dirty || nameControl?.touched)">
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.NAME_VALIDATION_REQUIRED' | translate }}
        </glxy-error>
      </glxy-form-field>
      <glxy-form-field *ngIf="(isSessionEventType$ | async) === true">
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.SESSION_TITLE' | translate }}
        </glxy-label>
        <input matInput required formControlName="sessionTitle" />
        <glxy-error *ngIf="sessionTitleControl.invalid && (sessionTitleControl?.dirty || sessionTitleControl?.touched)">
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.SESSION_TITLE_VALIDATION_REQUIRED' | translate }}
        </glxy-error>
      </glxy-form-field>
      <glxy-form-field *ngIf="(isSessionEventType$ | async) === false" [prefixText]="linkPrefix$ | async">
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LINK_LABEL' | translate }}
        </glxy-label>
        <input matInput required formControlName="slug" />
        <button *ngIf="slugChanged" mat-icon-button matSuffix (click)="revertSlug()">
          <mat-icon>undo</mat-icon>
        </button>
        <glxy-error *ngIf="slugControl.invalid && (slugControl?.dirty || slugControl?.touched)">
          {{ getSlugValidationError() }}
        </glxy-error>
      </glxy-form-field>
      <!--   Select meeting type & location   -->
      <div>
        <glxy-form-field>
          <glxy-label>
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LOCATION_LABEL' | translate }}
          </glxy-label>
          <mat-select formControlName="meetingLocation">
            <mat-option value="video"
              >{{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LOCATION.VIDEO' | translate }}
            </mat-option>
            <mat-option value="inPerson"
              >{{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LOCATION.IN_PERSON_MEETING' | translate }}
            </mat-option>
          </mat-select>
        </glxy-form-field>

        <mat-card *ngIf="meetingLocationControl.value === 'inPerson'" class="location-card">
          <mat-card-content>
            <glxy-form-field *ngIf="(isSessionEventType$ | async) === false">
              <glxy-label style="font-weight: bold">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LOCATION.IN_PERSON.SET_LOCATION_LABEL' | translate }}
              </glxy-label>
              <mat-radio-group layout="row" formControlName="radioSelection" class="radio-group">
                <mat-radio-button value="userSite" class="radio-option">
                  {{
                    'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LOCATION.IN_PERSON.USER_SITE_MEETING_LABEL'
                      | translate
                  }}
                </mat-radio-button>
                <mat-radio-button value="clientSite" class="radio-option">
                  {{
                    'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LOCATION.IN_PERSON.CLIENT_SITE_MEETING_LABEL'
                      | translate
                  }}
                </mat-radio-button>
              </mat-radio-group>
            </glxy-form-field>

            <glxy-form-field
              *ngIf="radioSelectionControl.value === 'userSite' || (isSessionEventType$ | async) === true"
              appearance="outline"
              class="fullwidth"
            >
              <glxy-label>
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.IN_PERSON_MEETING_INPUT_FIELD' | translate }}
              </glxy-label>
              <textarea
                matAutosizeMinRows="4"
                matInput
                matTextareaAutosize
                formControlName="inPersonAddress"
                [placeholder]="'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.IN_PERSON_MEETING_PLACEHOLDER' | translate"
              ></textarea>
            </glxy-form-field>

            <glxy-form-field
              *ngIf="radioSelectionControl.value === 'clientSite'"
              appearance="outline"
              class="fullwidth"
            >
              <glxy-label>
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.CLIENT_SITE_MEETING_INPUT_FIELD' | translate }}
              </glxy-label>
              <textarea
                matInput
                matTextareaAutosize
                matAutosizeMinRows="4"
                formControlName="locationGuidelines"
                maxlength="200"
                [placeholder]="
                  'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.CLIENT_SITE_MEETING_PLACEHOLDER' | translate
                "
              ></textarea>
              <mat-hint align="end">{{ locationGuidelinesControl?.value?.length || 0 }}/200</mat-hint>
            </glxy-form-field>

            <glxy-form-field
              *ngIf="radioSelectionControl.value === 'clientSite' || radioSelectionControl.value === 'userSite'"
              appearance="outline"
              class="fullwidth"
            >
              <div class="toggle-space">
                <mat-slide-toggle formControlName="isVideoLinkRequired">
                  <div class="slider-text">
                    {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.LOCATION.HYBRID_INPUT_FIELD' | translate }}
                  </div>
                </mat-slide-toggle>
              </div>
            </glxy-form-field>
          </mat-card-content>
        </mat-card>
        <glxy-form-field>
          <glxy-label>
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.DURATION_LABEL' | translate }}
          </glxy-label>
        </glxy-form-field>
        <mat-button-toggle-group class="duration-container" formControlName="durationSelection">
          <mat-button-toggle *ngFor="let duration of durations" class="duration" [value]="duration">
            {{ duration }}
          </mat-button-toggle>
          <mat-button-toggle class="duration" [value]="customDuration">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.CUSTOM_DURATION' | translate }}
          </mat-button-toggle>
        </mat-button-toggle-group>
        <glxy-error
          *ngIf="
            durationSelectionControl.invalid && (durationSelectionControl?.dirty || durationSelectionControl?.touched)
          "
        >
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.DURATION_SELECTION_REQUIRED' | translate }}
        </glxy-error>
        <glxy-form-field appearance="outline" class="fullwidth custom-duration" *ngIf="isCustomDuration">
          <glxy-label>
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.CUSTOM_DURATION_INPUT' | translate }}
          </glxy-label>
          <input matInput formControlName="durationInput" />
        </glxy-form-field>
      </div>
      <glxy-form-field appearance="outline" class="fullwidth">
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.DESCRIPTION' | translate }}
        </glxy-label>
        <textarea matAutosizeMinRows="4" matInput matTextareaAutosize formControlName="description"></textarea>
      </glxy-form-field>
      <glxy-form-field *ngIf="(isSessionEventType$ | async) === false">
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.COLOR_LABEL' | translate }}
        </glxy-label>
      </glxy-form-field>
      <div class="color-container" *ngIf="(isSessionEventType$ | async) === false">
        <button
          *ngFor="let color of colors"
          mat-mini-fab
          class="color-selector"
          [ngStyle]="{ 'background-color': color }"
          (click)="setColor(color)"
        >
          <mat-icon *ngIf="color === colorControl.value">check</mat-icon>
        </button>
      </div>

      <glxy-form-field *ngIf="(isSessionEventType$ | async) === true">
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.MAX_ATTENDEES' | translate }}
        </glxy-label>
        <input
          matInput
          required
          type="number"
          formControlName="maxAttendees"
          min="1"
          max="100"
          (wheel)="$event.preventDefault()"
        />
        <glxy-error *ngIf="maxAttendeesControl.invalid && (maxAttendeesControl?.dirty || maxAttendeesControl?.touched)">
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.MAXIMUM_ATTENDEES_VALIDATION_REQUIRED' | translate }}
        </glxy-error>
      </glxy-form-field>
    </form>
  </mat-expansion-panel>

  <!-- Registration Cutoff Section (Session Event Types Only) -->
  <mat-expansion-panel
    *ngIf="
      (!isUpdate || (loading$ | async) === false) && ((isSessionEventType$ | async) === true || showScheduleAccordion)
    "
    class="settings-card day-card"
    expanded="false"
  >
    <mat-expansion-panel-header class="expansion-header">
      <div class="title-description">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.REGISTRATION_CUTOFF.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="availability-card-description">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.REGISTRATION_CUTOFF.PROMPT' | translate }}
        </mat-panel-description>
      </div>
    </mat-expansion-panel-header>

    <form [formGroup]="form" class="form-class">
      <div class="mat-expansion-panel-body">
        <div class="range-type-section">
          <div class="range-type-group">
            <div class="radio-option">
              <div class="radio-button">
                <div class="controls-inline">
                  <glxy-form-field class="value-field" hideRequiredLabel="true">
                    <input
                      matInput
                      type="number"
                      formControlName="registrationCutoffValue"
                      [min]="0"
                      class="relative-input"
                    />
                    <glxy-error
                      *ngIf="
                        registrationCutoffValueControl.invalid &&
                        (registrationCutoffValueControl?.dirty || registrationCutoffValueControl?.touched)
                      "
                    >
                      {{ 'MEETING_SCHEDULER.BOOKING_LINK.REGISTRATION_CUTOFF_VALIDATION_REQUIRED' | translate }}
                    </glxy-error>
                  </glxy-form-field>

                  <glxy-form-field class="unit-field" hideRequiredLabel="true">
                    <mat-select formControlName="registrationCutoffUnit" class="unit-select">
                      <mat-option *ngFor="let unit of cutoffUnits" [value]="unit.value">
                        {{ unit.label }}
                      </mat-option>
                    </mat-select>
                  </glxy-form-field>

                  <span class="suffix-text">{{
                    'MEETING_SCHEDULER.SCHEDULE_SETTINGS.REGISTRATION_CUTOFF.SUFFIX' | translate
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="(!isUpdate || (loading$ | async) === false) && showScheduleAccordion"
    class="settings-card day-card"
    expanded="true"
  >
    <mat-expansion-panel-header class="expansion-header">
      <div class="title-description">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.SESSION.DATE_RANGE.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="availability-card-description">
          {{ 'MEETING_SCHEDULER.SESSION.DATE_RANGE.DESCRIPTION' | translate }}
        </mat-panel-description>
      </div>
    </mat-expansion-panel-header>
    <div class="settings-card-content">
      <form [formGroup]="form" class="form-class">
        <div class="date-time-inputs">
          <div class="date-time-input-width">
            <!-- Label is intentionally empty to avoid default the lable(date) -->
            <meeting-scheduler-calendar-date-picker
              [config]="calendarConfig"
              [selectedDate]="selectedDate"
              [label]="''"
              [placeholder]="'MEETING_SCHEDULER.SESSION.DATE_TIME.DATE.PLACEHOLDER'"
              [isSession]="isSessionEvent"
              [userIDs]="hostUserIds"
              (dateChange)="onDateChange($event)"
              (availableTimeSlotsChange)="onAvailableTimeSlotsChange($event)"
            ></meeting-scheduler-calendar-date-picker>
          </div>
          <div class="date-time-input-width">
            <glxy-form-field>
              <mat-select
                placeholder="{{ 'MEETING_SCHEDULER.SESSION.DATE_TIME.TIME.PLACEHOLDER' | translate }}"
                formControlName="selectedTime"
              >
                <mat-option *ngFor="let slot of availableTimeSlots" [value]="slot"> {{ slot }} </mat-option>
              </mat-select>
              <glxy-error
                *ngIf="selectedTimeControl.invalid && (selectedTimeControl?.dirty || selectedTimeControl?.touched)"
              >
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.TIME_VALIDATION_REQUIRED' | translate }}
              </glxy-error>
            </glxy-form-field>
          </div>
        </div>
      </form>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel
    #teamMemberSection
    data-testid="team-member-section"
    *ngIf="
      ((showHostUserSection$ | async) === true || (isSessionEventType$ | async) === true) &&
      (!isUpdate || (loading$ | async) === false)
    "
    class="settings-card"
    expanded="true"
  >
    <mat-expansion-panel-header class="expansion-header">
      <mat-panel-title class="settings-card-title" *ngIf="(isSessionEventType$ | async) === false">
        {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_MEMBER.TITLE' | translate }}
      </mat-panel-title>
      <mat-panel-title class="settings-card-title" *ngIf="(isSessionEventType$ | async) === true">
        {{ 'MEETING_SCHEDULER.BOOKING_LINK.SESSION_TEAM_MEMBER.TITLE' | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="form" class="team-member">
      <div *ngIf="(isSessionEventType$ | async) === false">
        <mat-radio-group formControlName="radioChoice" class="radio-group">
          <mat-radio-button [value]="TeamEventMeetingType.ROUND_ROBIN">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.ROUND_ROBING_LABEL' | translate }}
          </mat-radio-button>
          <mat-radio-button
            *ngIf="featurePriorityAssignmentEnabled$ | async"
            [value]="TeamEventMeetingType.PRIORITY_ROUND_ROBIN"
          >
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.PRIORITY_ASSIGNMENT_LABEL' | translate }}
          </mat-radio-button>
          <mat-radio-button [value]="TeamEventMeetingType.CLIENT_CHOICE">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.CLIENT_SELECTION_LABEL' | translate }}
          </mat-radio-button>
          <mat-radio-button [value]="TeamEventMeetingType.MULTI_HOST">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.MULTI_HOST_LABEL' | translate }}
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="selection-container">
        <div
          class="selection-text"
          *ngIf="
            (isSessionEventType$ | async) === false && radioChoiceValue !== TeamEventMeetingType.PRIORITY_ROUND_ROBIN
          "
        >
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_MEMBER.SELECTION' | translate }}
        </div>
        <div
          class="selection-text"
          *ngIf="
            (isSessionEventType$ | async) === false && radioChoiceValue === TeamEventMeetingType.PRIORITY_ROUND_ROBIN
          "
        >
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_MEMBER.PRIORITY_SELECTION' | translate }}
        </div>
        <div class="selection-text" *ngIf="(isSessionEventType$ | async) === true">
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.SESSION_TEAM_MEMBER.SELECTION' | translate }}
        </div>
      </div>
      <div class="parent-container">
        <glxy-form-field>
          <mat-chip-grid #teamMemberChipGrid aria-label="Team Member selection">
            <ng-container *ngFor="let teamMember of selectedTeamMembers; let i = index">
              <mat-chip-row *ngIf="hostUserIds?.includes(teamMember.userId)" (removed)="removeTeamMember(i)">
                <div class="team-member-list">
                  <span>
                    {{ teamMember.displayName | titlecase }}
                  </span>

                  <mat-icon *ngIf="!teamMember.isConfigured || !teamMember.isConnected" class="warn-icon"
                    >warning</mat-icon
                  >
                </div>
                <button matChipRemove [attr.aria-label]="'remove ' + teamMember.displayName">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            </ng-container>

            <input
              #teamMemberInput
              [placeholder]="'MEETING_SCHEDULER.BOOKING_LINK.ABOUT_SECTION.TEAM_MEMBER_PLACEHOLDER' | translate"
              [formControl]="teamMemberCtrl"
              [matChipInputFor]="teamMemberChipGrid"
              [matAutocomplete]="auto"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="addTeamMemberFromInput($event)"
            />
          </mat-chip-grid>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedTeamMember($event)">
            <mat-option
              *ngFor="let teamMember of filteredTeamMembers | async"
              [value]="teamMember"
              [disabled]="!teamMember.isConfigured || !teamMember.isConnected"
            >
              <div class="team-member-list">
                <span>
                  {{ teamMember.displayName | titlecase }}
                </span>
                <mat-icon *ngIf="!teamMember.isConfigured || !teamMember.isConnected" class="warn-icon"
                  >warning</mat-icon
                >
              </div>
            </mat-option>
          </mat-autocomplete>
          <glxy-error
            *ngIf="
              teamMemberCtrl.touched &&
              selectedTeamMembers.length < 1 &&
              radioChoiceValue !== TeamEventMeetingType.MULTI_HOST
            "
          >
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_MEMBERS_VALIDATION_REQUIRED' | translate: { count: 'one' } }}
          </glxy-error>

          <glxy-error
            *ngIf="
              teamMemberCtrl.touched &&
              selectedTeamMembers.length < 2 &&
              radioChoiceValue === TeamEventMeetingType.MULTI_HOST &&
              (isSessionEventType$ | async) === false
            "
          >
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_MEMBERS_VALIDATION_REQUIRED' | translate: { count: 'two' } }}
          </glxy-error>

          <glxy-error
            *ngIf="
              teamMemberCtrl.touched &&
              selectedTeamMembers.length < 1 &&
              radioChoiceControl.value === TeamEventMeetingType.MULTI_HOST &&
              (isSessionEventType$ | async) === true
            "
          >
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_MEMBERS_VALIDATION_REQUIRED' | translate: { count: 'one' } }}
          </glxy-error>
          <glxy-error
            *ngIf="
              teamMemberCtrl.touched &&
              selectedTeamMembers.length > 5 &&
              radioChoiceValue === TeamEventMeetingType.MULTI_HOST
            "
          >
            {{
              'MEETING_SCHEDULER.BOOKING_LINK.MAX_MULTI_HOST_TEAM_MEMBERS_VALIDATION_REQUIRED'
                | translate: { count: 'five' }
            }}
          </glxy-error>

          <glxy-error *ngIf="teamMemberCtrl.touched && teamMemberCtrl.errors?.['invalidTeamMembers']">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.INVALID_TEAM_MEMBERS_ERROR' | translate }}
          </glxy-error>
        </glxy-form-field>
      </div>

      <!-- Priority Assignment Drag and Delete Section -->
      <div *ngIf="radioChoiceValue === TeamEventMeetingType.PRIORITY_ROUND_ROBIN" class="priority-assignment-container">
        <div class="priority-team-members" cdkDropList (cdkDropListDropped)="onTeamMemberPriorityDrop($event)">
          <div
            class="priority-team-member-item"
            *ngFor="let teamMember of selectedTeamMembers; trackBy: trackByTeamMemberId; let i = index"
            cdkDrag
            [cdkDragData]="teamMember"
          >
            <mat-icon class="drag-handle">drag_indicator</mat-icon>
            <span class="member-name">{{ teamMember.displayName | titlecase }}</span>
            <mat-icon class="delete-button" (click)="onTeamMemberPriorityDelete(i)">delete_outline</mat-icon>
          </div>
        </div>
      </div>

      <div class="warning-spacing"></div>
      <glxy-alert *ngIf="(showAlert$ | async) === true" type="warning">
        {{ 'MEETING_SCHEDULER.BOOKING_LINK.TEAM_MEMBER.INDICATOR' | translate }}
      </glxy-alert>
    </form>
  </mat-expansion-panel>

  <mat-expansion-panel
    data-testid="availability-selection-panel"
    *ngIf="(!isUpdate || (loading$ | async) === false) && (isSessionEventType$ | async) === false"
    class="settings-card day-card"
    expanded="{{ isMultiHostMeetingType }}"
  >
    <mat-expansion-panel-header class="expansion-header">
      <div class="title-description">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="Availability-card-description">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.PROMPT' | translate }}
        </mat-panel-description>
      </div>
    </mat-expansion-panel-header>
    <div>
      <meeting-scheduler-settings-advanced-availability-card
        [meetingId]="meetingId"
        [selectedHosts]="selectedTeamMembers"
        [hostAvailability]="hostAvailability$"
        [isMultiHost]="isMultiHostMeetingType"
        [meetingDuration]="meetingDuration"
        [displayAvailabilitySelectionError]="displayAvailabilitySelectionError"
        [displayAvailabilitySelectionSlotError]="displayAvailabilitySelectionSlotError"
        [displayAvailabilityInsufficientDurationError]="displayAvailabilityInsufficientDurationError"
        (hasSelectedAvailability)="hasSelectedAvailability($event)"
        (selectedAvailability)="updatedSelectedAvailabilityValue($event)"
      ></meeting-scheduler-settings-advanced-availability-card>
    </div>
  </mat-expansion-panel>
  @if (
    (!isUpdate || (loading$ | async) === false) &&
    !showScheduleAccordion &&
    ((featureSMSEnabled$ | async) === false || context !== 'SMB')
  ) {
    <mat-expansion-panel class="settings-card" expanded="false">
      <mat-expansion-panel-header class="expansion-header">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="settings-card-description">
          {{ questionsCardDescription }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <glxy-form-field>
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.DEFAULT.QUESTIONS_SECTION' | translate }}
        </glxy-label>
      </glxy-form-field>
      <mat-accordion class="deafult-question-accordion">
        <mat-expansion-panel disabled>
          <mat-expansion-panel-header class="custom-panel-header">
            <mat-panel-title class="default-form-field-title">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_FIRST_NAME' | translate }}
            </mat-panel-title>
            <mat-panel-description class="default-form-field-description">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_TEXT' | translate }}
            </mat-panel-description>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
        <mat-expansion-panel disabled>
          <mat-expansion-panel-header class="custom-panel-header">
            <mat-panel-title class="default-form-field-title nowrap">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_LAST_NAME' | translate }}
            </mat-panel-title>
            <mat-panel-description class="default-form-field-description">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_TEXT' | translate }}
            </mat-panel-description>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
        <mat-expansion-panel disabled>
          <mat-expansion-panel-header class="custom-panel-header">
            <mat-panel-title class="default-form-field-title nowrap">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_EMAIL' | translate }}
            </mat-panel-title>
            <mat-panel-description class="default-form-field-description">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_EMAIL' | translate }}
            </mat-panel-description>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
        <mat-expansion-panel disabled>
          <mat-expansion-panel-header class="custom-panel-header">
            <mat-panel-title class="default-form-field-title nowrap">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_PHONE_NUMBER' | translate }}
            </mat-panel-title>
            <mat-panel-description class="default-form-field-description">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_PHONE_NUMBER' | translate }}
            </mat-panel-description>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
        <mat-expansion-panel disabled>
          <mat-expansion-panel-header class="custom-panel-header">
            <mat-panel-title class="default-form-field-title nowrap">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_COMMENTS' | translate }}
            </mat-panel-title>
            <mat-panel-description class="default-form-field-description">
              {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_TEXT_AREA' | translate }}
            </mat-panel-description>
          </mat-expansion-panel-header>
        </mat-expansion-panel>
      </mat-accordion>

      <glxy-form-field>
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.Custom.QUESTIONS_SECTION' | translate }}
        </glxy-label>
      </glxy-form-field>
      <mat-accordion
        #accordion="matAccordion"
        cdkDropList
        (cdkDropListDropped)="changeFieldOrder($event)"
        multi="true"
        class="drag-boundary"
      >
        <ng-container *ngFor="let field of customFieldsControl['controls']; let i = index">
          <mat-expansion-panel [formGroup]="field" cdkDrag cdkDragLockAxis="y" cdkDragBoundary=".drag-boundary">
            <mat-expansion-panel-header>
              <mat-panel-title class="form-field-title">
                <mat-icon cdkDragHandle class="handle-icon">drag_indicator</mat-icon>
                <div class="form-field-title-text">
                  <span>{{ field.value.label }}{{ field.value.required ? '*' : '' }}</span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="form-field-content">
              <div class="form-field-options">
                <mat-checkbox formControlName="required">
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.REQUIRED' | translate }}
                </mat-checkbox>
              </div>
              <mat-form-field appearance="outline" class="form-field-spacing">
                <mat-label>
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE' | translate }}
                </mat-label>
                <mat-select required formControlName="type">
                  <mat-option *ngFor="let fieldType of fieldTypeKeys" [value]="fieldType">
                    {{ describeFieldType(fieldType) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.LABEL' | translate }}
                </mat-label>
                <input matInput required formControlName="label" />
                <mat-error *ngIf="field.controls.label.invalid">
                  {{ fieldLabelErrorMessage(field.controls.label.value) }}
                </mat-error>
              </mat-form-field>
            </div>
            <mat-action-row>
              <button mat-stroked-button color="warn" (click)="deleteField(i)">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DELETE' | translate }}
              </button>
            </mat-action-row>
          </mat-expansion-panel>
        </ng-container>
        <div class="button-container">
          <button
            mat-stroked-button
            color="primary"
            class="add-field-button"
            [class.active]="!customFieldsControl.invalid"
            [disabled]="customFieldsControl.invalid"
            (click)="addFormField()"
          >
            <span class="plus-sign">+</span> {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.ADD' | translate }}
          </button>
        </div>
      </mat-accordion>

      <div *ngIf="customFieldsControl.invalid" class="custom-fields-errors">
        <mat-error *ngIf="fieldsHaveError('noDuplicates')">
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.ERROR_DUPLICATES' | translate }}
        </mat-error>
      </div>
    </mat-expansion-panel>
  }
  @if (
    (!isUpdate || (loading$ | async) === false) &&
    !showScheduleAccordion &&
    (featureSMSEnabled$ | async) === true &&
    context === 'SMB'
  ) {
    <mat-expansion-panel class="settings-card" expanded="false">
      <mat-expansion-panel-header class="expansion-header">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="settings-card-description">
          {{ questionsCardDescription }}
        </mat-panel-description>
      </mat-expansion-panel-header>
      <glxy-form-field>
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.DEFAULT.QUESTIONS_SECTION' | translate }}
        </glxy-label>
      </glxy-form-field>
      <form [formGroup]="form">
        <mat-accordion class="deafult-question-accordion">
          <mat-expansion-panel disabled>
            <mat-expansion-panel-header class="custom-panel-header">
              <mat-panel-title class="default-form-field-title">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_FIRST_NAME' | translate }}
              </mat-panel-title>
              <mat-panel-description class="default-form-field-description">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_TEXT' | translate }}
              </mat-panel-description>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
          <mat-expansion-panel disabled>
            <mat-expansion-panel-header class="custom-panel-header">
              <mat-panel-title class="default-form-field-title nowrap">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_LAST_NAME' | translate }}
              </mat-panel-title>
              <mat-panel-description class="default-form-field-description">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_TEXT' | translate }}
              </mat-panel-description>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
          <mat-expansion-panel disabled class="default-field-panel">
            <mat-expansion-panel-header class="custom-panel-header">
              <mat-panel-title class="default-form-field-title nowrap">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_EMAIL' | translate }}
                <glxy-badge *ngIf="showEmailBadge" [color]="'green'" class="field-badge">
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_EMAIL_CONFIRMATION' | translate }}
                </glxy-badge>
              </mat-panel-title>
              <mat-panel-description class="default-form-field-description">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_EMAIL' | translate }}
              </mat-panel-description>
              <div class="toggle-space default-field-toggle">
                <mat-slide-toggle formControlName="enableEmailField" (click)="$event.stopPropagation()" color="primary">
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.REQUIRED' | translate }}
                </mat-slide-toggle>
              </div>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
          <mat-expansion-panel disabled class="default-field-panel">
            <mat-expansion-panel-header class="custom-panel-header">
              <mat-panel-title class="default-form-field-title nowrap">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_PHONE_NUMBER' | translate }}
                <glxy-badge *ngIf="showPhoneBadge" [color]="'green'" class="field-badge">
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.PHONE_CONFIRMATION' | translate }}
                </glxy-badge>
              </mat-panel-title>
              <mat-panel-description class="default-form-field-description">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_PHONE_NUMBER' | translate }}
              </mat-panel-description>
              <div class="toggle-space default-field-toggle">
                @if (canSendSms) {
                  <mat-slide-toggle
                    formControlName="enablePhoneNumberField"
                    (click)="$event.stopPropagation()"
                    color="primary"
                  >
                    {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.REQUIRED' | translate }}
                  </mat-slide-toggle>
                }
                @if (!canSendSms) {
                  <button
                    mat-flat-button
                    color="primary"
                    (click)="$event.stopPropagation(); openRegisterConfirmationModal()"
                  >
                    {{ 'MEETING_SCHEDULER.BOOKING_LINK.SMS_REGISTRATION.REGISTER' | translate }}
                  </button>
                }
              </div>
            </mat-expansion-panel-header>
          </mat-expansion-panel>

          <!-- Show warning when no fields are required and canSendSms is true -->
          <glxy-alert *ngIf="canSendSms && areNoFieldsRequired" type="warning" class="channel-warning-alert">
            {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.WARNING_MESSAGE' | translate }}
          </glxy-alert>

          <!-- Show channel selection when both fields are required -->
          <mat-expansion-panel
            *ngIf="areBothFieldsRequired"
            disabled
            class="default-field-panel channel-selection-panel"
          >
            <mat-expansion-panel-header class="custom-panel-header">
              <mat-panel-title class="default-form-field-title channel-question-title">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.CHANNEL_QUESTION' | translate }}
              </mat-panel-title>
              <mat-panel-description class="default-form-field-description channel-buttons">
                <glxy-button-group class="inline-button-group">
                  <button
                    mat-stroked-button
                    type="button"
                    [class.selected]="notificationTypeControl?.value === NotificationType.SMS"
                    (click)="notificationTypeControl?.setValue(NotificationType.SMS)"
                  >
                    <mat-icon>phone_iphone</mat-icon>
                    {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.PHONE' | translate }}
                  </button>
                  <button
                    mat-stroked-button
                    type="button"
                    [class.selected]="notificationTypeControl?.value === NotificationType.EMAIL"
                    (click)="notificationTypeControl?.setValue(NotificationType.EMAIL)"
                  >
                    <mat-icon>mail_outline</mat-icon>
                    {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.EMAIL' | translate }}
                  </button>
                </glxy-button-group>
              </mat-panel-description>
            </mat-expansion-panel-header>
          </mat-expansion-panel>

          <mat-expansion-panel disabled>
            <mat-expansion-panel-header class="custom-panel-header">
              <mat-panel-title class="default-form-field-title nowrap">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DEFAULT_COMMENTS' | translate }}
              </mat-panel-title>
              <mat-panel-description class="default-form-field-description">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE_TEXT_AREA' | translate }}
              </mat-panel-description>
            </mat-expansion-panel-header>
          </mat-expansion-panel>
        </mat-accordion>
      </form>

      <glxy-form-field>
        <glxy-label>
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.Custom.QUESTIONS_SECTION' | translate }}
        </glxy-label>
      </glxy-form-field>
      <mat-accordion
        #accordion="matAccordion"
        cdkDropList
        (cdkDropListDropped)="changeFieldOrder($event)"
        multi="true"
        class="drag-boundary"
      >
        <ng-container *ngFor="let field of customFieldsControl['controls']; let i = index">
          <mat-expansion-panel [formGroup]="field" cdkDrag cdkDragLockAxis="y" cdkDragBoundary=".drag-boundary">
            <mat-expansion-panel-header>
              <mat-panel-title class="form-field-title">
                <mat-icon cdkDragHandle class="handle-icon">drag_indicator</mat-icon>
                <div class="form-field-title-text">
                  <span>{{ field.value.label }}{{ field.value.required ? '*' : '' }}</span>
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="form-field-content">
              <div class="form-field-options">
                <mat-checkbox formControlName="required">
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.REQUIRED' | translate }}
                </mat-checkbox>
              </div>
              <mat-form-field appearance="outline" class="form-field-spacing">
                <mat-label>
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.TYPE' | translate }}
                </mat-label>
                <mat-select required formControlName="type">
                  <mat-option *ngFor="let fieldType of fieldTypeKeys" [value]="fieldType">
                    {{ describeFieldType(fieldType) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>
                  {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.LABEL' | translate }}
                </mat-label>
                <input matInput required formControlName="label" />
                <mat-error *ngIf="field.controls.label.invalid">
                  {{ fieldLabelErrorMessage(field.controls.label.value) }}
                </mat-error>
              </mat-form-field>
            </div>
            <mat-action-row>
              <button mat-stroked-button color="warn" (click)="deleteField(i)">
                {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.DELETE' | translate }}
              </button>
            </mat-action-row>
          </mat-expansion-panel>
        </ng-container>
        <div class="button-container">
          <button
            mat-stroked-button
            color="primary"
            class="add-field-button"
            [class.active]="!customFieldsControl.invalid"
            [disabled]="customFieldsControl.invalid"
            (click)="addFormField()"
          >
            <span class="plus-sign">+</span> {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.ADD' | translate }}
          </button>
        </div>
      </mat-accordion>

      <div *ngIf="customFieldsControl.invalid" class="custom-fields-errors">
        <mat-error *ngIf="fieldsHaveError('noDuplicates')">
          {{ 'MEETING_SCHEDULER.BOOKING_LINK.QUESTIONS_SECTION.ERROR_DUPLICATES' | translate }}
        </mat-error>
      </div>
    </mat-expansion-panel>
  }

  <mat-expansion-panel
    *ngIf="(!isUpdate || (loading$ | async) === false) && (isSessionEventType$ | async) === false"
    class="settings-card"
    expanded="false"
  >
    <mat-expansion-panel-header class="expansion-header">
      <div class="title-description">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CUSTOMIZE_INVITATION_EMAIL.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description>
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CUSTOMIZE_INVITATION_EMAIL.DESCRIPTION' | translate }}
        </mat-panel-description>
      </div>
    </mat-expansion-panel-header>
    <form [formGroup]="form">
      <glxy-form-field>
        <glxy-label>
          {{ 'MEETING_SCHEDULER.CUSTOMIZE_INVITATION_EMAIL.SUBJECT' | translate }}
        </glxy-label>
        <input
          matInput
          formControlName="emailSubject"
          [placeholder]="
            'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CUSTOMIZE_INVITATION_EMAIL_SUBJECT.PLACEHOLDER' | translate
          "
        />
      </glxy-form-field>
      <glxy-form-field appearance="outline" class="fullwidth">
        <glxy-label>
          {{ 'MEETING_SCHEDULER.CUSTOMIZE_INVITATION_EMAIL.DESCRIPTION' | translate }}
        </glxy-label>
        <textarea
          matAutosizeMinRows="4"
          matInput
          matTextareaAutosize
          formControlName="emailDescription"
          [placeholder]="
            'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.CUSTOMIZE_INVITATION_EMAIL_DESCRIPTION.PLACEHOLDER' | translate
          "
        ></textarea>
      </glxy-form-field>
    </form>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="(!isUpdate || (loading$ | async) === false) && (isSessionEventType$ | async) === false"
    class="settings-card"
    expanded="false"
  >
    <mat-expansion-panel-header class="expansion-header">
      <div class="title-description">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.AVAILABILITY_INCREMENT.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="availability-card-description">
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.AVAILABILITY_INCREMENT.DESCRIPTION' | translate }}
        </mat-panel-description>
      </div>
    </mat-expansion-panel-header>
    <form [formGroup]="form">
      <mat-button-toggle-group formControlName="availabilityIncrement" [value]="null">
        <mat-button-toggle *ngFor="let option of increments" class="toggle-increments" [value]="option.seconds">
          {{ option.label }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </form>
    <glxy-form-field class="availability-hint">
      <glxy-label>
        {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.AVAILABILITY_INCREMENT.HINT' | translate }}
      </glxy-label>
    </glxy-form-field>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="(!isUpdate || (loading$ | async) === false) && !showScheduleAccordion"
    class="settings-card"
    [expanded]="isMultiHostMeetingType && (isSessionEventType$ | async) === false"
  >
    <mat-expansion-panel-header class="expansion-header">
      <div class="title-description">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION_BEFORE.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="Availability-card-description">
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION_BEFORE.DESCRIPTION' | translate }}
        </mat-panel-description>
      </div>
    </mat-expansion-panel-header>
    <form [formGroup]="form">
      <mat-button-toggle-group formControlName="bufferDurationBeforeMeeting">
        <mat-button-toggle *ngFor="let buffer of buffers" class="toggle-increments" [value]="buffer.seconds">
          {{ buffer.label }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </form>
    <glxy-form-field class="availability-hint">
      <glxy-label>
        {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION.HINT' | translate }}
      </glxy-label>
    </glxy-form-field>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="(!isUpdate || (loading$ | async) === false) && !showScheduleAccordion"
    class="settings-card"
    [expanded]="isMultiHostMeetingType && (isSessionEventType$ | async) === false"
  >
    <mat-expansion-panel-header class="expansion-header">
      <div class="title-description">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="availability-card-description">
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION.DESCRIPTION' | translate }}
        </mat-panel-description>
      </div>
    </mat-expansion-panel-header>
    <form [formGroup]="form">
      <mat-button-toggle-group formControlName="bufferDurationAfterMeeting">
        <mat-button-toggle *ngFor="let buffer of buffers" class="toggle-increments" [value]="buffer.seconds">
          {{ buffer.label }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </form>
    <glxy-form-field class="availability-hint">
      <glxy-label>
        {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.BUFFER_DURATION.HINT' | translate }}
      </glxy-label>
    </glxy-form-field>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="(!isUpdate || (loading$ | async) === false) && (isSessionEventType$ | async) === false"
    class="settings-card"
    expanded="false"
  >
    <mat-expansion-panel-header class="expansion-header">
      <div class="title-description">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.NOTICE_TIME.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="availability-card-description">
          {{ 'MEETING_SCHEDULER.SCHEDULE_MEETING_SETTINGS.NOTICE_TIME.DESCRIPTION' | translate }}
        </mat-panel-description>
      </div>
    </mat-expansion-panel-header>
    <form [formGroup]="form">
      <mat-button-toggle-group formControlName="noticeTime">
        <mat-button-toggle
          *ngFor="let advNotice of advanceNotice"
          class="toggle-increments"
          [value]="advNotice.seconds"
        >
          {{ advNotice.label }}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </form>
  </mat-expansion-panel>
  <mat-expansion-panel
    *ngIf="isUpdate && (loading$ | async) === false && (isSessionEventType$ | async) === false"
    class="settings-card day-card"
    expanded="false"
  >
    <mat-expansion-panel-header class="expansion-header">
      <div class="title-description">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.ADD_TO_WEBSITE.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="availability-card-description">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.ADD_TO_WEBSITE.PROMPT' | translate }}
        </mat-panel-description>
      </div>
    </mat-expansion-panel-header>
    <div>
      <meeting-scheduler-settings-add-to-website-card
        [isUpdate]="isUpdate"
        [calendarId]="calendarId"
        [name]="eventTypeName"
        [id]="meetingTypeId"
      ></meeting-scheduler-settings-add-to-website-card>
    </div>
  </mat-expansion-panel>

  <mat-expansion-panel
    *ngIf="
      (featureDateRangeEnabled$ | async) &&
      (!isUpdate || (loading$ | async) === false) &&
      (isSessionEventType$ | async) === false
    "
    class="settings-card day-card"
    expanded="false"
  >
    <mat-expansion-panel-header class="expansion-header">
      <div class="title-description">
        <mat-panel-title class="settings-card-title">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.DATE_RANGE.TITLE' | translate }}
        </mat-panel-title>
        <mat-panel-description class="availability-card-description">
          {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.DATE_RANGE.PROMPT' | translate }}
        </mat-panel-description>
      </div>
    </mat-expansion-panel-header>
    <form [formGroup]="form">
      <div class="range-type-section">
        <mat-radio-group formControlName="dateRangeType" class="range-type-group">
          <!-- Relative Date Range Option -->
          <div class="radio-option">
            <mat-radio-button [value]="DateRangeType.RELATIVE" class="radio-button">
              <div class="controls-inline">
                <glxy-form-field class="value-field" hideRequiredLabel="true">
                  <input matInput type="number" formControlName="relativeValue" [min]="1" class="relative-input" />
                </glxy-form-field>

                <glxy-form-field class="unit-field" hideRequiredLabel="true">
                  <mat-select formControlName="relativeUnit" class="unit-select">
                    <mat-option *ngFor="let unit of timeUnits" [value]="unit.value">
                      {{ unit.label }}
                    </mat-option>
                  </mat-select>
                </glxy-form-field>

                <span class="suffix-text">into the future</span>
              </div>
            </mat-radio-button>

            <!-- Error messages for relative option -->
            <div class="radio-option-errors" *ngIf="isRelativeMode">
              <glxy-error
                *ngIf="relativeValueControl?.invalid && (relativeValueControl?.dirty || relativeValueControl?.touched)"
              >
                {{ relativeValueError }}
              </glxy-error>
              <glxy-error
                *ngIf="relativeUnitControl?.invalid && (relativeUnitControl?.dirty || relativeUnitControl?.touched)"
              >
                Unit is required
              </glxy-error>
            </div>
          </div>

          <!-- Custom Date Range Option -->
          <div class="radio-option">
            <mat-radio-button [value]="DateRangeType.CUSTOM" class="radio-button">
              <div class="controls-inline">
                <glxy-form-field class="date-field" hideRequiredLabel="true">
                  <input
                    matInput
                    [matDatepicker]="startPicker"
                    formControlName="startDate"
                    placeholder="Select start date"
                    [min]="today"
                    readonly
                  />
                  <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                  <mat-datepicker #startPicker></mat-datepicker>
                </glxy-form-field>

                <span class="date-label">to</span>
                <glxy-form-field class="date-field" hideRequiredLabel="true">
                  <input
                    matInput
                    [matDatepicker]="endPicker"
                    formControlName="endDate"
                    placeholder="Select end date"
                    [min]="today"
                    readonly
                  />
                  <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                  <mat-datepicker #endPicker></mat-datepicker>
                </glxy-form-field>
              </div>
            </mat-radio-button>

            <!-- Error messages for custom option -->
            <div class="radio-option-errors" *ngIf="isCustomMode">
              <glxy-error *ngIf="startDateControl?.invalid && (startDateControl?.dirty || startDateControl?.touched)">
                {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.ALERTS.DATE_RANGE.START_DATE_REQUIRED' | translate }}
              </glxy-error>
              <glxy-error *ngIf="endDateControl?.invalid && (endDateControl?.dirty || endDateControl?.touched)">
                {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.ALERTS.DATE_RANGE.END_DATE_REQUIRED' | translate }}
              </glxy-error>
              <glxy-error *ngIf="hasDateRangeError">
                {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.ALERTS.DATE_RANGE.INVALID_RANGE' | translate }}
              </glxy-error>
            </div>
          </div>
        </mat-radio-group>
      </div>
    </form>
  </mat-expansion-panel>

  <glxy-sticky-footer [rightAligned]="true">
    <!-- Show both Create and Schedule buttons for session event types when not in update mode and not showing schedule accordion -->
    <div
      *ngIf="(isSessionEventType$ | async) === true && !isUpdate && !showScheduleAccordion; else singleButton"
      class="button-group"
    >
      <button mat-stroked-button type="submit" (click)="createOrUpdateMeetingType()">
        {{ buttonText }}
      </button>
      <button mat-flat-button color="primary" type="button" (click)="createAndSchedule()" class="schedule-button">
        {{ 'MEETING_SCHEDULER.BOOKING_LINK.SCHEDULE_SESSION_NOW' | translate }}
      </button>
    </div>

    <!-- Default single button for all other cases -->
    <ng-template #singleButton>
      <button mat-flat-button color="primary" type="submit" (click)="createOrUpdateMeetingType()">
        {{ buttonText }}
      </button>
    </ng-template>
  </glxy-sticky-footer>
</div>
